import { useFlattenListItems } from './useFlattenListItems';
import { useListParsedState } from './useListParsedState';
/**
 * Take array of items as a argument and returns parsed representation of this data structure to work with
 */
export const useList = ({ items, expandedById, getId }) => {
    const { itemsById, groupsState, itemsState, initialState } = useListParsedState({
        items,
        getId,
    });
    const { visibleFlattenIds, idToFlattenIndex } = useFlattenListItems({
        items,
        /**
         * By default controlled from list items declaration state
         */
        expandedById: expandedById || initialState.expandedById,
        getId,
    });
    return {
        items,
        visibleFlattenIds,
        idToFlattenIndex,
        itemsById,
        groupsState,
        itemsState,
        initialState,
    };
};
